import { render } from "./AppSnackBar.vue?vue&type=template&id=6f4a4097&scoped=true"
import script from "./AppSnackBar.vue?vue&type=script&lang=js"
export * from "./AppSnackBar.vue?vue&type=script&lang=js"

import "./AppSnackBar.vue?vue&type=style&index=0&id=6f4a4097&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4a4097"]])

export default __exports__